<template>
    <div class="deal_index_box">
        <!-- 修改管理員資訊 -->
        <div class="deal_title">
            <div>帳戶設定<span>》</span>修改管理員資訊</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="deal_content_box">
            <div class="deal_content_title">修改最高權限管理員資訊</div>
            <div class="deal_content">
							<!-- 內容1 -->
							<div class="center_box">
									<!-- 1 -->
									<div class="pass_box">
										<span>*交易</span>密碼：
										<el-input placeholder="請輸入交易密碼" v-model="tradersPass" show-password maxlength='6'></el-input>
									</div>
									<!-- 2 -->
									<div class="phone_box">
										<span>*</span>新的綁定手機：
										<el-select v-model="phoneSelect" placeholder="请选择">
											<el-option
												v-for="item in phoneOptions"
												:key="item.value"
												:label="item.label"
												:value="item.value">
											</el-option>
										</el-select>
										<el-input placeholder="請輸入手機號碼" v-model="phoneVal" ></el-input>
										<el-button class="account_button" @click="clickVerification()" :disabled="disabledTF">{{buttonText}}</el-button>
										<span class="verification_text">沒有收到驗證碼？</span>
									</div>
									<!-- 3 -->
									<div>
											<span>*</span>簡訊驗證碼：
											<el-input placeholder="請輸入驗證碼" v-model="veriVal" ></el-input>
									</div>
							</div>
							<!-- 內容2-若僅修改手機下方證件欄位免填 -->
							<div class="text-red">《若僅修改手機下方證件欄位免填》</div>
							<!-- 內容2-配置修改 -->
							<div class="data_box">

								<!-- 1 -->
								<div>
									<span>證件類型：</span>
									<el-radio v-model="formMail.radio" label="1">國民身份證（限台灣）</el-radio>
									<el-radio v-model="formMail.radio" label="2">護照（限海外人士）</el-radio>
								</div>
								<!-- 2 -->
								<div>
									<span>證件<span class="text-black">正面照：</span></span>
									<input type="file" id="file_front"  @change="fileFront($event)" accept="image/*">
									<!-- <div v-show="formMailSucc.fileFront">
										<img id="front_img" src="" alt="">
									</div>
									<div class="file_text">
										{{formMailRemind.fileFront}}
										<i class="el-icon-error" v-show="formMailTF.fileFront"></i>
									</div> -->
								</div>
								<!-- 3 -->
								<div>
									<span>證件<span class="text-black">反面照：</span></span>
									<input type="file" id="file_front"  @change="fileFront($event)" accept="image/*">
									<!-- <div v-show="formMailSucc.fileFront">
										<img id="front_img" src="" alt="">
									</div>
									<div class="file_text">
										{{formMailRemind.fileFront}}
										<i class="el-icon-error" v-show="formMailTF.fileFront"></i>
									</div> -->
								</div>
								<!-- 4 -->
								<div>
									<span>身份證字號：</span>
									<el-input placeholder="海外人士請填寫護照號碼" v-model="formMail.identity" ></el-input>
								</div>
								<!-- 5 -->
								<div>
									<span>真實姓名：</span>
									<el-input placeholder="須與證件上所載姓名相符" v-model="formMail.identity" ></el-input>
								</div>
								<!-- 6 -->
								<div class="certificate_box">
									<span>發證日期：</span>
									<span class="span_minguo">民國</span>
									<!-- 年 -->
									<el-select v-model="formMail.yearValue" placeholder="" class="identity_box_select select_year">
										<el-option
										v-for="item in yearOptions"
										:key="item.value"
										:label="item.label"
										:value="item.value"
										>
										</el-option>
									</el-select>
									<span class="span_text">年</span>
									<!-- 月 -->
									<el-select v-model="formMail.monthValue" placeholder="" class="identity_box_select">
										<el-option
										v-for="item in monthOptions"
										:key="item.value"
										:label="item.label"
										:value="item.value"
										>
										</el-option>
									</el-select>
									<span class="span_text">月</span>
									<!-- 日 -->
									<el-select v-model="formMail.dayValue" placeholder="" class="identity_box_select">
										<el-option
										v-for="item in dayOptions"
										:key="item.value"
										:label="item.label"
										:value="item.value"
										>
										</el-option>
									</el-select>
									<span class="span_last">日</span>
								</div>
								<!-- 7 -->
								<div>
									<span>發證地點：</span>
									<el-select v-model="formMail.siteValue" placeholder="" class="identity_box_select">
										<el-option
										v-for="item in siteOptions"
										:key="item.value"
										:label="item.label"
										:value="item.value"
										>
										</el-option>
									</el-select>
								</div>
								<!-- 8 -->
								<div>
									<span>領補換類別：</span>
									<el-radio v-model="formMail.certificateRadio" label="1">初發</el-radio>
									<el-radio v-model="formMail.certificateRadio" label="2">補發</el-radio>
									<el-radio v-model="formMail.certificateRadio" label="3">換發</el-radio>
									<!-- 身份驗證 -->
									<el-button type="primary" class="authentication_button">身份驗證</el-button>
								</div>
							</div>
							<!-- END-內容2-配置修改 -->
							<!-- 按鈕-BOX -->
							<div class="button_box">
								<el-button plain class="authentication_button" @click="goAccount()">返回</el-button>
								<el-button type="primary" class="authentication_button">送出</el-button>
							</div>
							<!-- END-按鈕-BOX -->
            </div>
        </div>
        <!-- deal_index_box -->
    </div>
</template>

<script>
export default {
    name: 'LoginDealBills',
    data() {
			return {
				// 修改最高權限管理員資訊
				tradersPass: '',
				phoneOptions: [{
						value: '选项1',
						label: '+886'
					}],
				phoneSelect: '',
				phoneVal: '',
				veriVal: '',
				buttonText: '點擊發送驗證碼',
				disabledTF: false,
				// 資料修改
				formMail:{
					radio: '1',
					identity: '',
					yearValue: '',
					monthValue: '',
					dayValue: '',
					siteValue: '',
					certificateRadio: '1',
				},
				yearOptions: [
					{
						value: '108',
						label: '108'
					}, {
						value: '107',
						label: '107'
					}, {
						value: '106',
						label: '106'
					},{
						value: '105',
						label: '105'
					},{
						value: '104',
						label: '104'
					},{
						value: '103',
						label: '103'
					},{
						value: '102',
						label: '102'
					},{
						value: '101',
						label: '101'
					},{
						value: '100',
						label: '100'
					},{
						value: '099',
						label: '099'
					},{
						value: '098',
						label: '098'
					},{
						value: '097',
						label: '097'
					},{
						value: '096',
						label: '096'
					},{
						value: '095',
						label: '095'
					},{
						value: '094',
						label: '094'
					}
				],
				monthOptions: [{
						value: '01',
						label: '01'
					}, {
						value: '02',
						label: '02'
					}, {
						value: '03',
						label: '03'
					}, {
						value: '04',
						label: '04'
					}, {
						value: '05',
						label: '05'
					}, {
						value: '06',
						label: '06'
					}, {
						value: '07',
						label: '07'
					}, {
						value: '08',
						label: '08'
					}, {
						value: '09',
						label: '09'
					}, {
						value: '10',
						label: '10'
					}, {
						value: '11',
						label: '11'
					}, {
						value: '12',
						label: '12'
				}],
				dayOptions: [{
						value: '01',
						label: '01'
					}, {
						value: '02',
						label: '02'
					}, {
						value: '03',
						label: '03'
					},{
						value: '04',
						label: '04'
					}, {
						value: '05',
						label: '05'
					}, {
						value: '06',
						label: '06'
					},{
						value: '07',
						label: '07'
					}, {
						value: '08',
						label: '08'
					}, {
						value: '09',
						label: '09'
					},{
						value: '10',
						label: '10'
					}, {
						value: '11',
						label: '11'
					}, {
						value: '12',
						label: '12'
					},{
						value: '13',
						label: '13'
					},{
						value: '14',
						label: '14'
					},{
						value: '15',
						label: '15'
					},{
						value: '16',
						label: '16'
					}, {
						value: '17',
						label: '17'
					}, {
						value: '18',
						label: '18'
					},{
						value: '19',
						label: '19'
					},{
						value: '20',
						label: '20'
					},{
						value: '21',
						label: '21'
					},{
						value: '22',
						label: '22'
					}, {
						value: '23',
						label: '23'
					}, {
						value: '24',
						label: '24'
					},{
						value: '25',
						label: '25'
					},{
						value: '26',
						label: '26'
					}, {
						value: '27',
						label: '27'
					}, {
						value: '28',
						label: '28'
					},{
						value: '29',
						label: '29'
					}, {
						value: '30',
						label: '30'
					}, {
						value: '31',
						label: '31'
				}],
				siteOptions: [{
						value: '10001',
						label: '北縣'
					}, {
						value: '10002',
						label: '宜縣'
					}, {
						value: '10003',
						label: '桃縣'
					}, {
						value: '10004',
						label: '竹縣'
					}, {
						value: '10005',
						label: '苗縣'
					}, {
						value: '10006',
						label: '中縣'
					}, {
						value: '10007',
						label: '彰縣'
					}, {
						value: '10008',
						label: '投縣'
					}, {
						value: '10009',
						label: '雲縣'
					}, {
						value: '10010',
						label: '嘉縣'
					}, {
						value: '10011',
						label: '南縣'
					}, {
						value: '10012',
						label: '高縣'
					}, {
						value: '10013',
						label: '屏縣'
					}, {
						value: '10014',
						label: '東縣'
					}, {
						value: '10015',
						label: '花縣'
					}, {
						value: '10016',
						label: '澎縣'
					}, {
						value: '10017',
						label: '基市'
					}, {
						value: '10018',
						label: '竹市'
					}, {
						value: '10020',
						label: '嘉市'
					}, {
						value: '09007',
						label: '連江'
					}, {
						value: '09020',
						label: '金門'
					}, {
						value: '63000',
						label: '北市'
					}, {
						value: '64000',
						label: '高市'
					}, {
						value: '65000',
						label: '新北市'
					}, {
						value: '66000',
						label: '中市'
					}, {
						value: '67000',
						label: '南市'
					}, {
						value: '68000',
						label: '桃市'
					}
				],
        // return
        }
    },
    methods: {
		// 返回
		goAccount(){
			this.$router.push('/login/account');
		},
		// FUN-發送ajax，01-驗證碼
		axiosVerification(){
			// axios.get(this.$store.state.axiosVerificationUrl, {
			// 	params:{
			// 		phone: this.formAccount.phoneNumber
			// 	}
			// }).then((res) => {
			// 	// console.log(res.data);
			// 	this.status = res.data.status;
			// 	this.message = res.data.message.vf_code;
			// 	this.stateRegister = res.data.message.stage;
			// 	if(this.stateRegister != '2-1'){
			// 		this.stateList = res.data.message.list;
			// 	}
			// 	if(this.status){
			// 		this.message = res.data.message.vf_code;
			// 		this.disabledTF = true;
			// 		this.ShowSucc = true;
			// 		this.ShowError = false;
			// 		this.verify = "已發送驗證碼";
			// 		// 倒計時
			// 		this.buttonText = this.timeto + "秒後，可再次發送";
			// 		let count = setInterval(() => {
			// 				this.timeto-=1;
			// 				this.buttonText = this.timeto + "秒後，可再次發送";
			// 				if(this.timeto < 0){
			// 					clearInterval(count);
			// 					this.buttonText = '發送驗證碼';
			// 					this.timeto = this.countTime;
			// 					this.disabledTF = false;
			// 					return
			// 				}
			// 		},1000);
			// 	} else {
			// 	this.ShowSucc = false;
			// 	this.ShowError = true;
			// 	this.remind = "手機已存在，歡迎重新登入";
			// 	}
			// })
		},
		clickVerification() {
			// // 请输入手机号码
			// if(this.formAccount.phoneNumber == ''){
			// 	this.ShowSucc = false;
			// 	this.ShowError = true;
			// 	this.remind = "請輸入手機號碼";
			// 	return
			// }else{
			// 	const reg =  /^(\+886\s)?[0]{1}[9]{1}\d{8}$/;
			// 	if(!reg.test(this.formAccount.phoneNumber)){
			// 		this.ShowSucc = false;
			// 		this.ShowError = true;
			// 		this.remind = "請輸入正確的手機號碼";
			// 		return
			// 	}
			// }
			// // 发送ajax；
			// this.axiosVerification();
		},
		// FUN-【上传】-身份证正面-02
		fileFront(e){
			// this.formMail.fileFront = e.target.files[0];
			// this.formMailTF.fileFront = false;
			// this.formMailSucc.fileFront = true;
			// let rd = new FileReader();
			// rd.readAsDataURL(this.formMail.fileFront);
			// rd.onload=function (e) {
			// 			document.getElementById('front_img').src=rd.result;
			// 			document.getElementById('front_img_to').src=rd.result;
						
			// 	};
		},
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 交易管理》交易订单 */
    .deal_index_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        margin: 30px 0;
        display: flex;
        justify-content: flex-start;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
		.text-red {
			margin: 20px 0 30px;
			color: #e73262;
			font-weight: bold;
		}

    .time_box {
        font-size: 17px;
        margin-bottom: 33px;
        letter-spacing: 1px;
    }
    .time_box > span {
        color: #e73262;
        margin: 0 5px;
    }
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        /* height: 53.6vw; */
        min-height: 800px;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 38px 40px;
        padding-top: 26px;
    }
		.center_box > div+div{
			margin-top: 10px;
		}
		.center_box .el-input {
			width: 200px;
		}
		.center_box span {
			color: #e73262
		}
		/* 綁定手機 */
		.phone_box .el-select {
			width: 100px;
			margin-right: 10px;
		}
		.account_button,.account_button:hover {
			background: #ff771a;
			color: white;
			margin: 0 10px;
		}
		.center_box .verification_text {
			cursor: pointer;
			color: #4d80e7;
		}
		/* 配置修改 */
		.data_box .el-input {
			width: 200px;
		}
		.data_box >div >span {
			display: inline-block;
			width: 90px;
		}
		.data_box > div+div {
			/* color: #777777; */
			margin-top: 20px;
		}
		.data_box .text-black {
			/* color: black; */
			font-weight: bolder;
		}
		.data_box .el-select {
			width: 100px;
			margin-right: 10px;
		}
		.data_box .span_text {
			width: 13px;
			margin-right: 10px;
		}
		.data_box .span_minguo {
			width: 26px;
			margin-right: 10px;
		}
		/* 身份驗證 */
		.authentication_button {
			padding: 5px 10px;
		}
		.button_box {
			margin-top: 40px;
		}
		.authentication_button+.authentication_button {
			margin-left: 14px;
		}
</style>
